import { render, staticRenderFns } from "./StepOneAmount.vue?vue&type=template&id=3012724e&scoped=true"
import script from "./StepOneAmount.vue?vue&type=script&lang=js"
export * from "./StepOneAmount.vue?vue&type=script&lang=js"
import style0 from "./StepOneAmount.vue?vue&type=style&index=0&id=3012724e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3012724e",
  null
  
)

export default component.exports